import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

const Wrapper = styled.div`
  padding: 0 20px;

  ${breakpoint('desktop')`
    margin: 0 auto;
    max-width: 1000px;
    padding-left: 0;
    padding-right: 0;
  `}
`

export default Wrapper
